import type { TBaseValidators, TValidator } from '../types';
import { formatValidator } from './format';
import { futureDateValidator } from './future-date-validator';
import { maxLengthValidator } from './max-length';
import { maximumValueValidator } from './maximum';
import { minLengthValidator } from './min-length';
import { minimumValueValidator } from './minimum';
import { minimumAgeValueValidator } from './minimum-age';
import { minimumTimeDistanceValueValidator } from './minimum-time-distance';
import { pastDateValidator } from './past-date-validator';
import { patternValueValidator } from './pattern';
import { requiredValueValidator } from './required';
import { sumValueValidator } from './sum';

export const baseValidatorsMap: Record<TBaseValidators, TValidator<any, any>> = {
  required: requiredValueValidator,
  minLength: minLengthValidator,
  maxLength: maxLengthValidator,
  pattern: patternValueValidator,
  minimum: minimumValueValidator,
  maximum: maximumValueValidator,
  format: formatValidator,
  minimumAge: minimumAgeValueValidator,
  futureDate: futureDateValidator,
  pastDate: pastDateValidator,
  minimumTimeDistance: minimumTimeDistanceValueValidator,
  sum: sumValueValidator,
};

export const validatorsExtends: Record<string, TValidator<any, any>> = {};
